import React from "react";
import css from "./index.m.css";
import UpdateCard from "../updateCard";
import {urlDomainDeal} from "@src/utils/common";

export default (props) => {
  const { updateContentList } = props;
  return (
    <div className={css["content-update-box"]}>
      {updateContentList.map((item, index) => {
        return (
          <UpdateCard
            key={index}
            cardTitle={item.title}
            imgSrc={urlDomainDeal(item.icon)}
            cardDesc={item.desc}
          />
        );
      })}
    </div>
  );
};
